<template>
  <v-dialog :max-width="!$isMobile ? activeWidth : '100%'"
            class="custom-modal"
            :persistent="activeComponent?.isDisabledCloseModal"
            @update:model-value="closeModal"
            :model-value="isActiveModal">
    <template v-slot:default="{ isActive }">
      <transition name="fade-opacity-modal" mode="out-in">
        <v-card v-if="activeComponent"
                class="modal" :class="{'big' : activeComponent?.type === 'big'}">
          <v-card-title class="title-header-modal d-flex justify-space-between align-center flex-column">
            <icon-default :size="'mini'"
                          @click="closeModal"
                          :color="'light-purple'"
                          @mouseleave="focusFalse"
                          @mouseenter="focusTrue">
              <IconCross/>
            </icon-default>
            <medium-title>  {{ activeComponent?.title || isActiveModalName?.title }} </medium-title>
          </v-card-title>

          <component
              @closeModal="closeModal"
              :is="activeComponent.component"/>
        </v-card>
      </transition>
    </template>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";
import {markRaw} from "vue";
import ModalAgreement from "@/components/entities/modals/ModalAgreement.vue";
import IconCross from "@/assets/icons/ui/cross.svg?inline"
import ModalCropImg from "@/components/entities/modals/ModalCropImg.vue";
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import ModalTags from "@/components/entities/modals/ModalTags.vue";
export default {
  name: "ModalLayout",
  components: {IconDefault, MediumTitle, IconCross},
  watch: {
    isActiveModal() {
      if(this.activeComponent) {
        this.activeWidth = this.activeComponent.width || 405
      }
    }
  },
  data() {
    return {
      focusParam: false,
      activeWidth: 405
    }
  },
  computed: {
    ...mapGetters(['isActiveModal', 'isActiveModalName']),
    activeComponent() {
      return this.isActiveModal
          ? this.modal.find(item => item.name === this.isActiveModalName.name)
          : null
    },
    modal() {
      return  [
        {
          name: "ModalAgreement",
          title: 'Совершить действие',
          component: markRaw(ModalAgreement),
          width: 435
        },
        {
          name: "ModalCropImg",
          title: 'Обрезать фотографию',
          component: markRaw(ModalCropImg),
          width: 600
        },
        {
          name: "ModalTags",
          component: markRaw(ModalTags),
          width: 400
        },
      ]
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}

// ВЫЗОВ
// this.MODAL({
//   name: НАЗВАНИЕ МОДАЛКИ,
//   info: НУЖНАЯ ИНФА В МОДАЛКЕ (ПРОПС),
//   onComplete: (данные) => {
//     ЧТО СДЕЛАТЬ ПОСЛЕ ЗАКРЫТИЯ МОДАЛКИ
//   },
// })

// внутри модалки
// onComplete: () => null

// mounted() {
//   this.setInitialParams(this.isActiveModalName);
// },
// setInitialParams(params) {
//   this.onComplete = params.onComplete;
// },

// this.onComplete({
//   reason: this.valueInput
// });
</script>

<style scoped lang="scss">
.modal {
  border-radius: 16px !important;
  background: white;
  border: 3px solid rgba(var(--color-dark-purple-rgba), .1);
  position: relative;
  height: 100%;
  width: 100%;
  padding: 32px;
  //box-shadow: 0 40px 80px rgba(40, 40, 53, .7) !important;

  @media(max-width: 769px) {
    padding: 16px;
  }
  .medium-title-container{
    font-weight: 700;
    color: var(--color-dark-green)
  }
  .icon-container {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 2px;
  }
}
.custom-modal > .v-overlay__content > .v-card {
  border-radius: 10px;
}
.v-card-title {
  padding: 0 !important;
}

.title-header-modal {
  margin-bottom: 32px;
}

</style>